import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import ArrowDown from 'utils/images/arrow-down.svg';
import { v4 as uuidv4 } from 'uuid';
import * as Yup from 'yup';
import { OPTION_GROUPS_MODALS } from '../../constants';
import useEditor from '../../hooks/use-editor';
import {
  costPriceValidation,
  vatRateValidation,
  requiredNameWithMaxLength,
  requiredOptionsPrice,
} from '../../utils/validation';
import Checkbox from '../shared/Checkbox';
import EditorButtons from '../shared/EditorButtons';
import OptionGroupEditor from './components/option-groups-editor';

const Header = styled.h1`
  font-family: Geomanist;
  font-style: normal;
  font-weight: normal;
  font-size: 25px;
  line-height: 25px;
  text-align: center;
  letter-spacing: -0.4px;
  margin-bottom: 0px;
  margin-top: 25px;
`;

const OptionGroupEditorContainer = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid #dedede;
  width: 100%;
  height: 100%;
  background: #f3f4f6;
  box-sizing: border-box;
  border-radius: 5px;
  @media only screen and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
    width: 660px;
  }
`;

const OptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  text-align: left !important;
`;
const ShowOptionContainer = styled.div`
  width: 98%;
  height: 100%;
  background: #f3f4f6;
  border: 1px solid #dedede;
  box-sizing: border-box;
  border-radius: 5px;
  padding-bottom: 30px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  @media (min-width: 600px) {
    width: 100%;
  }

  @media only screen and (min-width: 900px) {
    padding: 30px -1px;
  }

  @media (min-width: 1024px) {
    width: 100%;
  }
`;
const SelectedOptionsHeader = styled.p`
  font-size: 15px;
  line-height: 16px;
  font-weight: 500;
  padding-top: 15px;
  padding-left: 30px;
  letter-spacing: -0.2px;
`;

const CTAButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  max-width: 100%;
  flex-basis: 100%;
  margin-top: 10px;
  margin-bottom: -25px;
`;

const Border = styled.div`
  height: 1px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid #eeeeee;
  margin-top: 70px;

  @media (max-width: 375px) {
    margin-top: 0px;
  }
`;

const ExpanderArrow = styled.div`
  width: 12px;
  height: 7px;
  line-height: 12px;
  transform: rotate(270deg);
  cursor: pointer;
  margin-left: -6px;

  ${props =>
    props.expanded &&
    css`
      transform: rotate(0deg);
      cursor: pointer;
      margin-bottom: 9px;
      margin-left: 0px;
      margin-right: -6px;
    `}

  ${props =>
    props.hide &&
    css`
      visibility: hidden;
    `}
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 29px;

  ${props =>
    props.expanded &&
    css`
      margin-left: 25px;
      margin-top: 0px;
      cursor: default;
    `}
`;

const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: baseline;

  ${props =>
    props.expanded &&
    css`
      margin-left: 20px;
      margin-top: 0px;
      cursor: default;
    `}
`;
const CategoryWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 25px;

  ${props =>
    props.expanded &&
    css`
      margin-left: 19px;
      margin-top: 0px;
      cursor: default;
    `}
`;
const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: baseline;
  margin-left: 82px;
`;
const MenuName = styled.h3`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  margin-left: 15px;
  cursor: pointer;
`;
const CategoryName = styled.h3`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-family: 'Basier Circle';
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: #000000;
  cursor: pointer;
  margin-left: 12px;
`;

const Check = styled(Checkbox)`
  padding: 0 !important;
  border: none;
  background-color: transparent;
  font-family: 'Basier Circle';
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  font-style: normal;
  letter-spacing: -0.2px;
`;

const validation = Yup.object({
  name: requiredNameWithMaxLength,
  children: Yup.array().of(
    Yup.object().shape({
      price: requiredOptionsPrice,
      cost_price: costPriceValidation,
      vat_rate_eat_in: vatRateValidation,
      vat_rate_takeaway: vatRateValidation,
      name: requiredNameWithMaxLength,
    })
  ),
});

function OptionGroupCreateModal({
  close,
  group,
  parent,
  setSelectedDialog,
  setGroups,
  menus,
  allGroups,
  isManageMode,
  product,
}) {
  let initiallySelectedProducts = {};
  if (product) {
    initiallySelectedProducts = { [product.id]: true };
  }
  const selectedProductsInitialState = ((group || {}).productIds || []).reduce(
    (a, v) => ({ ...a, [v]: true }),
    {}
  );
  const [checkedProduct, setCheckedProduct] = useState(
    { ...selectedProductsInitialState, ...initiallySelectedProducts } || {}
  );

  const [isExpanded, setIsExpanded] = useState({});

  let createMode = true;
  if (group) {
    createMode = false;
  }
  const {
    childErrors,
    loading,
    item: editableItem,
    onFieldChange,
    onChildEditorSetup,
    onAddChild,
    updateOgHandler,
    submitOgHandler,
    deleteOgHandler,
    onChangeChild,
    onRemoveChild,
  } = useEditor({
    init: group || {
      children: [{ variantType: 'single', choice_limit: 0 }],
    },
    parent,
    validation,
    type: 'group',
    path: [],
    setShowEditor: () => true,
  });

  const newOptionGroup = createMode ? editableItem.children[0] : editableItem;

  const productIds = Object.entries(checkedProduct)
    .filter(x => x[1] === true)
    .map(x => x[0]);

  const handleCreate = async () => {
    try {
      await submitOgHandler(productIds, createdOptionGroupId => {
        if (!product) {
          // CREATE MODE
          setGroups([
            ...(allGroups || []),
            {
              ...newOptionGroup,
              id: createdOptionGroupId,
              productIds: [...productIds, `tbc-${uuidv4()}`],
            },
          ]);
          setSelectedDialog(OPTION_GROUPS_MODALS.LIST);
          close();
        } else {
          setGroups([
            ...(allGroups || []),
            { ...newOptionGroup, id: createdOptionGroupId, productIds },
          ]);
          setSelectedDialog(OPTION_GROUPS_MODALS.LIST);
          if (!isManageMode) {
            close();
          }
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  const handleUpdate = async () => {
    try {
      await updateOgHandler(productIds);
      setGroups([
        ...allGroups.filter(g => g.id !== newOptionGroup.id),
        { ...newOptionGroup, productIds },
      ]);
      setSelectedDialog(OPTION_GROUPS_MODALS.LIST);
      if (!isManageMode) {
        close();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteOgHandler();
      setGroups(allGroups.filter(g => g.id !== newOptionGroup.id));
      setSelectedDialog(OPTION_GROUPS_MODALS.LIST);
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <Container>
      <DialogTitle
        id="responsive-dialog-title"
        style={{ marginTop: '25px', padding: '0px' }}
      >
        <Header>Customisation Options</Header>
      </DialogTitle>
      <DialogActions
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '35px',
          marginBottom: '10px',
        }}
      >
        <OptionGroupEditorContainer>
          <OptionGroupEditor
            key={`variant-editor-${editableItem.id}`}
            variant={createMode ? editableItem.children[0] : editableItem}
            error={childErrors[editableItem.id]}
            onChange={v => onChangeChild(v)}
            onParentFieldChange={onFieldChange}
            onRemove={v => onRemoveChild(v)}
            onEditorSetup={v => onChildEditorSetup(v)}
            createMode={createMode}
            onAdd={onAddChild}
          />
        </OptionGroupEditorContainer>
      </DialogActions>
      <OptionsContainer>
        <ShowOptionContainer>
          <SelectedOptionsHeader>Apply this group to: </SelectedOptionsHeader>
          {(menus || []).map(menu => {
            return (
              <React.Fragment key={menu.id}>
                <Wrapper>
                  <ExpanderArrow
                    expanded={isExpanded[menu.id]}
                    id={`${menu.id}`}
                    onClick={() => {
                      const expansionSttus = {
                        ...isExpanded,
                        [menu.id]: !isExpanded[menu.id],
                      };
                      setIsExpanded(expansionSttus);
                    }}
                  >
                    <img alt="expand arrow" src={ArrowDown} />
                  </ExpanderArrow>
                  <HeaderWrapper
                    expanded={isExpanded[menu.id]}
                    id={`${menu.id}`}
                    onClick={() => {
                      const expansionSttus = {
                        ...isExpanded,
                        [menu.id]: !isExpanded[menu.id],
                      };
                      setIsExpanded(expansionSttus);
                    }}
                  >
                    <MenuWrapper>
                      <MenuName>{menu.name}</MenuName>
                    </MenuWrapper>
                  </HeaderWrapper>
                </Wrapper>
                {isExpanded[menu.id] &&
                  (menu.children || []).map(category => {
                    return (
                      <React.Fragment key={category.id}>
                        <Wrapper
                          expanded={isExpanded[category.id]}
                          id={`${category.id}`}
                          onClick={() => {
                            const categoryStatus = {
                              ...isExpanded,
                              [category.id]: !isExpanded[category.id],
                            };
                            setIsExpanded(categoryStatus);
                          }}
                        >
                          <CategoryWrapper>
                            <ExpanderArrow
                              expanded={isExpanded[category.id]}
                              id={`${category.id}`}
                              onClick={() => {
                                const categoryStatus = {
                                  ...isExpanded,
                                  [category.id]: !isExpanded[category.id],
                                };
                                setIsExpanded(categoryStatus);
                              }}
                            >
                              <img alt="expand arrow" src={ArrowDown} />
                            </ExpanderArrow>
                            <CategoryName>{category.name}</CategoryName>
                          </CategoryWrapper>
                        </Wrapper>
                        {isExpanded[category.id] &&
                          (category.children || []).map(product => {
                            return (
                              <CheckboxWrapper
                                id={`product-checkw-${product.id}`}
                              >
                                <Check
                                  isChecked={checkedProduct[product.id]}
                                  onSelect={() => {
                                    const checkStatus = {
                                      ...checkedProduct,
                                      [product.id]: !checkedProduct[product.id],
                                    };
                                    setCheckedProduct(checkStatus);
                                  }}
                                  noMargin={true}
                                  key={`p-${product.id}`}
                                  value={product.id}
                                  label={product.name}
                                  id={`product-check-${product.id}`}
                                />
                              </CheckboxWrapper>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
              </React.Fragment>
            );
          })}
        </ShowOptionContainer>
      </OptionsContainer>
      <CTAButtonsWrapper>
        <EditorButtons
          type="group"
          create={createMode}
          loading={loading}
          onCancel={close}
          onSubmit={handleCreate}
          onUpdate={handleUpdate}
          onDelete={handleDelete}
        />
      </CTAButtonsWrapper>
      <Border />
    </Container>
  );
}

export default OptionGroupCreateModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/GlobalOptions/option-group-create-modal.jsx